export default __webpack_public_path__ + "static/media/looney_talks.1d272294.jpeg";